function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_791_18322)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 1.5,
    transform: "matrix(0.130526 0.991445 0.991445 -0.130526 12.2393 19.5332)",
    fill: "#8B8C95",
    style: (_ref2 = {
      fill: "#8B8C95"
    }, _defineProperty(_ref2, "fill", "color(display-p3 0.5451 0.5490 0.5843)"), _defineProperty(_ref2, "fillOpacity", 1), _ref2)
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 1.5,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 5.13013 15.1016)",
    fill: "#8B8C95",
    style: (_ref3 = {
      fill: "#8B8C95"
    }, _defineProperty(_ref3, "fill", "color(display-p3 0.5451 0.5490 0.5843)"), _defineProperty(_ref3, "fillOpacity", 1), _ref3)
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 1.5,
    transform: "matrix(-0.608761 0.793353 0.793353 0.608761 6.84253 17.4912)",
    fill: "#8B8C95",
    style: (_ref4 = {
      fill: "#8B8C95"
    }, _defineProperty(_ref4, "fill", "color(display-p3 0.5451 0.5490 0.5843)"), _defineProperty(_ref4, "fillOpacity", 1), _ref4)
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 1.5,
    transform: "matrix(-0.258819 0.965926 0.965926 0.258819 9.3396 19.0479)",
    fill: "#8B8C95",
    style: (_ref5 = {
      fill: "#8B8C95"
    }, _defineProperty(_ref5, "fill", "color(display-p3 0.5451 0.5490 0.5843)"), _defineProperty(_ref5, "fillOpacity", 1), _ref5)
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 1.5,
    transform: "matrix(0.5 0.866025 0.866025 -0.5 15.1008 18.8701)",
    fill: "#8B8C95",
    style: (_ref6 = {
      fill: "#8B8C95"
    }, _defineProperty(_ref6, "fill", "color(display-p3 0.5451 0.5490 0.5843)"), _defineProperty(_ref6, "fillOpacity", 1), _ref6)
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 1.5,
    transform: "matrix(0.793353 -0.608761 -0.608761 -0.793353 18.4042 8.02734)",
    fill: "#8B8C95",
    style: (_ref7 = {
      fill: "#8B8C95"
    }, _defineProperty(_ref7, "fill", "color(display-p3 0.5451 0.5490 0.5843)"), _defineProperty(_ref7, "fillOpacity", 1), _ref7)
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 1.5,
    transform: "matrix(0.866025 0.5 0.5 -0.866025 18.1206 16.3994)",
    fill: "#8B8C95",
    style: (_ref8 = {
      fill: "#8B8C95"
    }, _defineProperty(_ref8, "fill", "color(display-p3 0.5451 0.5490 0.5843)"), _defineProperty(_ref8, "fillOpacity", 1), _ref8)
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.64
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 1.5,
    transform: "matrix(0.991445 0.130526 0.130526 -0.991445 19.3347 13.7217)",
    fill: "#8B8C95",
    style: (_ref9 = {
      fill: "#8B8C95"
    }, _defineProperty(_ref9, "fill", "color(display-p3 0.5451 0.5490 0.5843)"), _defineProperty(_ref9, "fillOpacity", 1), _ref9)
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 1.5,
    transform: "matrix(0.965926 -0.258819 -0.258819 -0.965926 19.4341 10.7803)",
    fill: "#8B8C95",
    style: (_ref10 = {
      fill: "#8B8C95"
    }, _defineProperty(_ref10, "fill", "color(display-p3 0.5451 0.5490 0.5843)"), _defineProperty(_ref10, "fillOpacity", 1), _ref10)
  })), /*#__PURE__*/React.createElement("rect", {
    width: 4.5,
    height: 1.5,
    transform: "matrix(0.5 -0.866025 -0.866025 -0.5 16.3999 5.88086)",
    fill: "#8B8C95",
    style: (_ref11 = {
      fill: "#8B8C95"
    }, _defineProperty(_ref11, "fill", "color(display-p3 0.5451 0.5490 0.5843)"), _defineProperty(_ref11, "fillOpacity", 1), _ref11)
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_791_18322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 9,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.5ac93daaa13d31194c457a513323549a.svg";
export { ForwardRef as ReactComponent };